import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import api from "../../services/api"
import { Toast } from '../../shared/Toast';
import { roles } from "../../utils/constants";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function ResetPassword() {
    const navigate = useNavigate();

    const { id } = useParams();
    const [code, setCode] = useState("")
    const [advId, setAdvId] = useState("")
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordsMatch, setPasswordsMatch] = useState(true);
    const [oldPswd, setOldPswd] = useState('');
    const [oldPswdMatch, setOldPswdMatch] = useState(true);
    const [passwordError, setPasswordError] = useState('');

    const validatePassword = (pwd) => {
        if (pwd.length < 8) return 'Password must be at least 8 characters';
        if (!/[a-z]/.test(pwd)) return 'Must include at least one lowercase letter';
        if (!/[A-Z]/.test(pwd)) return 'Must include at least one uppercase letter';
        if (!/\d/.test(pwd)) return 'Must include at least one number';
        if (!/[!@#$%^&*\-?+~]/.test(pwd)) return 'Must include at least one special character (!@#$%^&*-?+~)';
        return '';
    };

    const updatePassword = async (oldPassword, newPassword, confirmPassword) => {
        try {
            let res = await api({
                url: "/login/updatePswd",
                method: "POST",
                responseType: "json",
                data: {
                    old_pswd: oldPassword,
                    new_pswd: newPassword,
                    confirm_pswd: confirmPassword,
                    department: roles.advertiser,
                    adv_id: advId
                }

            });
            if (res.code === 200) {
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
                setPasswordsMatch(true);
                setOldPswdMatch(true);
                setOldPswd('');
                navigate('/');
                setCode('')
            } else {
                Toast("error", res.data.message)
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    const handlePswdValidate = async (e) => {
        e.preventDefault();
        const pwdErr = validatePassword(newPassword);
        if (pwdErr) { setPasswordError(pwdErr); return; }
        setPasswordError('');
        if (oldPswd !== oldPassword) { setOldPswdMatch(false); return; }
        if (newPassword !== confirmPassword) { setPasswordsMatch(false); return; }
        await updatePassword(oldPassword, newPassword, confirmPassword);
    };
    const resetPassword = async (id) => {
        try {
            const res = await api({
                url: `/login/resetPswd/${id}`,
                method: "POST",
                responseType: "json",
                data: { id: id }
            })
            if (res?.code === 200) {
                const response = res?.data
                if (response.status === 1) {
                    setCode(1)
                    // Toast("error", "Your Password has been already reset")
                    return
                }
                else if (response.status === 3) {
                    setCode(3)
                    // Toast("error", "Password reset Link has been Expired")
                    return
                }
                else if (response.status === 0) {
                    setCode(0)
                    // Toast("error", "UnAuthorized Action")
                    return
                } else if (response.status === 200) {
                    setCode(200);
                    setAdvId(response?.advId);
                    setOldPswd(response?.oldPswd)
                }
            }
        } catch (error) {
            console.log("Error @ Reset Password", error)
        }
    }

    useEffect(() => {
        resetPassword(id)
    }, [])
    return (
        <>
            {(code === 200) ? <div>
                <Modal
                    className="modal-top"
                    show={true}
                    onHide={false}
                    backdrop="static"
                    animation={false}
                    centered
                >
                    <ModalHeader>
                        <ModalTitle>
                            <p className="mb-0">Reset Password</p>
                        </ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form onSubmit={handlePswdValidate}>
                            <div className="form-group">
                <label htmlFor="oldPassword">Old Password:</label>
                <input
                  type="password"
                  className="form-control"
                  id="oldPassword"
                  name="oldPassword"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  required
                />
                            </div>
                            {!oldPswdMatch && (
                                <p className="text-danger m-1">Old Password that you have entered is Incorrect!</p>
                            )}
                            <div className="form-group">
                                <label htmlFor="newPassword">New Password:</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="newPassword"
                                    name="newPassword"
                                    value={newPassword}
                                    onChange={(e) => { setNewPassword(e.target.value); setPasswordError(''); }}
                                    required
                                />
                                {passwordError && <p className="text-danger m-1">{passwordError}</p>}
                                <small className="text-muted">Min 8 chars, uppercase, lowercase, number & special character (!@#$%^&*-?+~)</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor="confirmPassword">Confirm New Password:</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>
                            {!passwordsMatch && (
                                <p className="text-danger m-1">New Password and Confirm Password doesn't match!</p>
                            )}
                            <button type="submit" className="btn btn-primary mt-3 w-100">
                                Reset
                            </button>
                        </form>
                    </ModalBody>
                </Modal>
            </div> : ((code === 1) ? <div className="container">
                <div className="message">
                    Your Password has been already reset !
                </div>
            </div> : ((code === 3) ? <div className="container">
                <div className="message">
                    Password reset Link has been Expired !
                </div>
            </div> : ((code === 0) ? <div className="container">
                <div className="message">
                    UnAuthorized Action !
                </div>
            </div> : null)))}

        </>
    )
}

export default ResetPassword
